import { render, staticRenderFns } from "./CompCard.vue?vue&type=template&id=8c222ca4"
import script from "./CompCard.vue?vue&type=script&lang=ts"
export * from "./CompCard.vue?vue&type=script&lang=ts"
import style0 from "./CompCard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageComponent: require('/app/components/base/ImageComponent/ImageComponent.vue').default})
